import {Filters} from '../../constants/filter/filters';
import {CatalogFilterOptionsStoreClass} from './base';
import Dispatcher from "../../dispatcher";

class TyreCatalogFilterOptionsStoreClass extends CatalogFilterOptionsStoreClass {
    getInitialState() {
        const filterOptions = [
            Filters.WIDTH,
            Filters.HEIGHT,
            Filters.DIAMETER,
            Filters.SPEED_INDEX,
            Filters.LOAD_INDEX,
            Filters.POSTCODE,
            Filters.MANUFACTURER,
            Filters.MODEL,
            Filters.VEHICLE_TYPE,
            Filters.USAGE,
            Filters.PRICE_MIN,
            Filters.PRICE_MAX,
            Filters.VEHICLE_TYRES,
            Filters.TECHNOLOGY,
            Filters.LABEL_NOISE,
            Filters.LABEL_WET_GRIP,
            Filters.LABEL_FUEL_EFFICIENCY,
            Filters.UTQG_TREADWEAR_GROUP,
            Filters.UTQG_TRACTION,
            Filters.UTQG_TEMPERATURE,
            Filters.SEASON,
            Filters.EV,
            Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP,
            Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP,
        ];
        return super.initFilterOptions(filterOptions);
    }
}

const TyreCatalogFilterOptionsStore = new TyreCatalogFilterOptionsStoreClass(Dispatcher);
export default TyreCatalogFilterOptionsStore;
